import { Action } from '@ngrx/store';
import { LandLineListInterface } from '../../models/land-line-list.interface';

export enum ELandLineListActions {
  GetLandLineList = '[LANDLINE] Get land line list',
  GetLandLineListSuccess = '[LANDLINE] Get land line list success',
  GetLandLineListFailure = '[LANDLINE] Get land line list failure',
}

export class GetLandLineList implements Action {
  public readonly type = ELandLineListActions.GetLandLineList;
  constructor() {}
}

export class GetLandLineListSuccess implements Action {
  public readonly type = ELandLineListActions.GetLandLineListSuccess;
  constructor(public payload: Array<LandLineListInterface>) {}
}

export class GetLandLineListFailure implements Action {
  public readonly type = ELandLineListActions.GetLandLineListFailure;
}

export type LandLineListActions = GetLandLineList | GetLandLineListSuccess | GetLandLineListFailure;
